import { render, staticRenderFns } from "./UserBill.vue?vue&type=template&id=54c6ed10"
import script from "./UserBill.vue?vue&type=script&lang=ts"
export * from "./UserBill.vue?vue&type=script&lang=ts"
import style0 from "./UserBill.vue?vue&type=style&index=0&id=54c6ed10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports